// Utilitaires pour gérer les URLs d'images selon l'environnement
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '/images/placeholder.jpg';
  
  // Si c'est déjà une URL complète
  if (imagePath.startsWith('http')) return imagePath;
  
  // Déterminer l'URL de base selon l'environnement
  const isProduction = process.env.NODE_ENV === 'production';
  const baseUrl = isProduction 
    ? 'https://api-tn.licorne-academy.com' 
    : 'https://api-tn.licorne-academy.com';
  
  // Si c'est un upload récent (commence par /uploads/)
  if (imagePath.startsWith('/uploads/')) {
    return `${baseUrl}${imagePath}`;
  }
  
  // Si c'est une image statique (dans public/images/)
  if (imagePath.startsWith('/images/')) {
    return imagePath; // Servie directement par le frontend
  }
  
  // Par défaut, traiter comme un upload
  return `${baseUrl}/uploads/${imagePath}`;
};

// Version pour les uploads dans l'admin
export const getUploadUrl = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  return isProduction 
    ? 'https://api-tn.licorne-academy.com/api/upload'
    : 'https://api-tn.licorne-academy.com/api/upload';
};